import { BookChapterViewer } from './BookChapterViewer'
import { withBookChapterViewer } from './withBookChapterViewer'

const ConnectedBookChapterViewer = withBookChapterViewer(BookChapterViewer)

export { ConnectedBookChapterViewer as BookChapterViewer }
